// extracted by mini-css-extract-plugin
export default {"progress":"index_progress__9EslG","label":"index_label__nOg8C","chapterWrap":"index_chapterWrap__HpzrC","chapter":"index_chapter__+4g8k","num":"index_num__So1CD"};